const {host} = window.location;
const prefix = host.includes('localhost') ? 'dev.'
  : host.match(/(.*)wacc.indigitall.com$/)?.[1] || 'eu1.';

const { REACT_APP_ADMIN_BASE_URL, REACT_APP_SOCKET_BASE_URL, REACT_APP_AUTH_AGENT_EP, REACT_APP_SOCKET_PATH } = process.env;

const ADMIN_BASE_URL = REACT_APP_ADMIN_BASE_URL || `https://${prefix}api.indigitall.com`;
const SOCKET_BASE_URL = REACT_APP_SOCKET_BASE_URL || `https://${prefix}chat-api.indigitall.com`;
const SOCKET_PATH = REACT_APP_SOCKET_PATH || '/socket';
const AUTH_AGENT_EP = REACT_APP_AUTH_AGENT_EP || '/v1/chat/agent/auth';

export { SOCKET_BASE_URL, ADMIN_BASE_URL, SOCKET_PATH, AUTH_AGENT_EP };
